import { createSlice  } from '@reduxjs/toolkit'

const initialState = {
    holidayList: {
        requesting: false,
        items: [],
        pagination: {
            current_page: 1,
            per_page: 10,
            total: 0,
        },
        error: null,
        success: false,
        filters: {},
    },
    
    holidayDetails: {
        requesting: false,
        error: null,
        success: false,
        data: null
    },
  };

export const holidaySlice = createSlice({
  name: 'holiday',
  initialState,
  reducers: {
    getHolidayList: (state, action) => {
        state.holidayList.requesting = true;
        state.holidayList.error = null;
        state.holidayList.items = [];
        state.holidayList.success = false;
        state.holidayList.filters = action.payload;
    },
    getHolidayListSuccess: (state, action) => {
        const { data, current_page, per_page, total} = action.payload;
        state.holidayList.requesting = false;        
        state.holidayList.items = data;
        state.holidayList.success = true; 
        state.holidayList.pagination.current_page = current_page;
        state.holidayList.pagination.per_page = per_page;
        state.holidayList.pagination.total = total;
    },
    getHolidayListFail: (state, action) => {        
        state.holidayList.requesting = false;
        state.holidayList.error = action.payload;
    },
    getHolidayDetails: (state) => {
        state.holidayDetails.requesting = true;
        state.holidayDetails.error = null;
        state.holidayDetails.data = null;
        state.holidayDetails.success = false; 
    },
    getHolidayDetailsSuccess: (state, action) => {
        state.holidayDetails.requesting = false;
        state.holidayDetails.data = action.payload;
        state.holidayDetails.success = true; 
    },
    getHolidayDetailsFail: (state, action) => {        
        state.holidayDetails.requesting = false;
        state.holidayDetails.error = action.payload;
    },
    doHolidayCreate: (state) => {
        state.holidayDetails.requesting = true;
        state.holidayDetails.error = null;
        state.holidayDetails.data = null;
        state.holidayDetails.success = false; 
    },
    doHolidayUpdate: (state) => {
        state.holidayDetails.requesting = true;
        state.holidayDetails.error = null;
        state.holidayDetails.data = null;
        state.holidayDetails.success = false; 
    },
    doHolidayDelete: (state) => {
        state.holidayDetails.requesting = true;
        state.holidayDetails.error = null;
        state.holidayDetails.data = null;
        state.holidayDetails.success = false; 
    },

    doHolidayReset: (state) => {		
      state.holidayDetails.data = null;
    },
  },
})

export const { 
    getHolidayList, getHolidayListSuccess, getHolidayListFail,
    getHolidayDetails, getHolidayDetailsSuccess, getHolidayDetailsFail,
    doHolidayCreate, doHolidayUpdate, doHolidayDelete,
    doHolidayReset,
} = holidaySlice.actions

export default holidaySlice.reducer